// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { motion } from "framer-motion";
// import { TextField, Container, Typography } from "@mui/material";
// // import catImage from "../images/homecat.png";
// import catImage from "../images/homecat1.avif";
// // import dogImage from "../images/homeimg.png";
// import dogImage from "../images/homeimg.avif";
// import IOS1 from "../images/IOS1.jpeg";
// import IOS2 from "../images/IOS2.jpeg";
// import IOS3 from "../images/IOS3.jpeg";
// import IOS4 from "../images/IOS4.jpeg";
// import And1 from "../images/android1.jpeg";
// import And2 from "../images/android2.jpeg";
// import And3 from "../images/android3.jpeg";
// import And4 from "../images/android4.jpeg";
// import Navbar from "./Navbar.js";
// import axiosInstance from "../api/axios";
// import FingerprintJS from "@fingerprintjs/fingerprintjs";
// import { Helmet } from 'react-helmet-async';

// const Signup = () => {
//   const [formData, setFormData] = useState({
//     full_name: "",
//     email: "",
//     password: "",
//     confirmPassword: "",
//     priceId: "price_1SpBOi046YZkLcO5SDUsSyB4",
//   });
//   const [loading, setLoading] = useState(false);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [errors, setErrors] = useState({});
//   const [showInstructions, setShowInstructions] = useState(false);

//   const { full_name, email, password, confirmPassword, priceId } = formData;

//   const onChange = (e) =>
//     setFormData({ ...formData, [e.target.name]: e.target.value });

//   const validateForm = () => {
//     const newErrors = {};
//     if (!full_name) newErrors.full_name = "Full name is required";
//     if (!email) {
//       newErrors.email = "Email is required";
//     } else {
//       const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//       if (!emailRegex.test(email)) {
//         newErrors.email =
//           "Email is invalid. Please enter a valid email address.";
//       }
//     }
//     if (!password) {
//       newErrors.password = "Password is required";
//     } else {
//       const passwordRegex =
//         /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;
//       if (!passwordRegex.test(password)) {
//         newErrors.password =
//           "Password must be at least 6 characters long, contain at least one uppercase letter, one lowercase letter, one number, and one special character.";
//       }
//     }
//     if (password !== confirmPassword) {
//       newErrors.confirmPassword = "Passwords do not match";
//     }
//     return newErrors;
//   };

//   const getDeviceFingerprint = async () => {
//     const fp = await FingerprintJS.load();
//     const result = await fp.get();
//     return result.visitorId;
//   };

//   const getUserIP = async () => {
//     try {
//       const response = await fetch("https://api.ipify.org?format=json");
//       const data = await response.json();
//       return data.ip;
//     } catch (err) {
//       console.error("Error fetching IP:", err);
//       return "unknown";
//     }
//   };

//   const checkEmailExists = async (email) => {
//     try {
//       const fingerprint = await getDeviceFingerprint();
//       const ip = await getUserIP();

//       const response = await axiosInstance.post("/check-email", {
//         email,
//         fingerprint,
//         ip,
//       });
//       return response.data;
//     } catch (error) {
//       console.error("Error checking email", error);
//       return { exists: false, verified: false, error: "Error checking email" };
//     }
//   };

//   //   const handleSignUp = async (e) => {
//   //     e.preventDefault();
//   //     const formErrors = validateForm();
//   //     if (Object.keys(formErrors).length > 0) {
//   //       setErrors(formErrors);
//   //       return;
//   //     }
//   //     const emailExists = await checkEmailExists(email);
//   //  if (emailExists.exists) {
//   //       setErrors({ email: "This email is already in use" });
//   //       return;
//   //     }

//   //     if (!emailExists.verified) {
//   //       setErrors({ email: emailExists.error || "Invalid email address" });
//   //       return;
//   //     }

//   //     try {
//   //       setLoading(true);
//   //       setErrorMessage("");
//   //       localStorage.removeItem("userDetails");
//   //       const ip = await getUserIP();
//   //       const fingerprint = await getDeviceFingerprint();

//   //       localStorage.setItem(
//   //         "userDetails",
//   //         JSON.stringify({ full_name, email, password, ip, fingerprint,isGoogle: "No",googleId:"No" })
//   //       );

//   //       const checkoutResponse = await axiosInstance.post(
//   //         "/create-checkout-session",
//   //         {
//   //           full_name,
//   //           email,
//   //           priceId,
//   //         }
//   //       );

//   //       const { sessionId } = checkoutResponse.data;

//   //       const stripe = window.Stripe(
//   //         process.env.REACT_APP_STRIPE_PUBLIC_KEY
//   //       );
//   //       const { error } = await stripe.redirectToCheckout({ sessionId });

//   //       if (error) {
//   //         setErrorMessage(error.message);
//   //       }
//   //     } catch (error) {
//   //       setErrorMessage(
//   //         error.response ? error.response.data.detail : "Error during sign-up"
//   //       );
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   };

//   const handleSignUp = async (e) => {
//     e.preventDefault();
//     setErrorMessage("");
//     setErrors({});

//     const formErrors = validateForm();
//     if (Object.keys(formErrors).length > 0) {
//       setErrors(formErrors);
//       return;
//     }

//     setLoading(true);
//     try {
//       const emailCheck = await checkEmailExists(email);
//       if (emailCheck.exists) {
//         setErrors({ email: "This email is already in use" });
//         return;
//       }
//       if (!emailCheck.verified) {
//         setErrors({ email: emailCheck.error || "Email not verified" });
//         return;
//       }

//       setShowInstructions(true);
//     } catch (err) {
//       setErrorMessage("Error during sign-up");
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleConfirmAndProceed = async () => {
//     setErrorMessage("");
//     setLoading(true);

//     let fingerprint = null;
//     let ip = null;

//     try {
//       fingerprint = await getDeviceFingerprint();
//       ip = await getUserIP();

//       const payload = {
//         full_name,
//         email,
//         password,
//         ip,
//         fingerprint,
//         priceId,
//         isGoogle: "No",
//         googleId: "No",
//       };

//       const createResp = await axiosInstance.post(
//         "/create-checkout-session",
//         payload
//       );
//       const { sessionId } = createResp.data || {};

//       if (!sessionId) {
//         throw new Error("No sessionId returned from server");
//       }

//       const stripe = window.Stripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
//       const { error } = await stripe.redirectToCheckout({ sessionId });

//       if (error) {
//         setErrorMessage(error.message || "Stripe redirect error");
//       }
//     } catch (err) {
//       console.error("Error in confirm+proceed:", err);
//       setErrorMessage(
//         err.response?.data?.detail || err.message || "Checkout failed"
//       );
//     } finally {
//       fingerprint = null;
//       ip = null;

//       setFormData((prev) => ({ ...prev, password: "", confirmPassword: "" }));

//       setLoading(false);
//       setShowInstructions(false);
//     }
//   };

//   const textVariants = {
//     hidden: { opacity: 0, y: 50 },
//     visible: { opacity: 1, y: 0, transition: { duration: 1 } },
//   };

//   const buttonVariants = {
//     hover: { backgroundColor: "#BDA697", transition: { duration: 0.3 } },
//   };
//   const imageVariants = {
//     hidden: { opacity: 0, x: -100 },
//     visible: { opacity: 1, x: 0, transition: { duration: 1 } },
//   };
//   const linkVariants = {
//     hidden: { opacity: 0, y: 20 },
//     visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
//   };

//   return (
//     <section className="relative text-center mt-20 pt-16">
//       <Helmet>
//   <title>Sign Up Free – Furbabies.AI</title>
//   <meta name="description" content="Create your free Furbabies.AI account and start monitoring your pet's health and nutrition with AI today. No credit card required." />
// </Helmet>
//       <Navbar />
//       <Container maxWidth="sm" className="mt-10">
//         <motion.h1
//           variants={textVariants}
//           initial="hidden"
//           animate="visible"
//           className="text-5xl  lg:text-[60px] lg:leading-[70px] font-bold text-gray-900 "
//         >
//           Care Today
//         </motion.h1>
//         <motion.p
//           variants={textVariants}
//           initial="hidden"
//           animate="visible"
//           transition={{ delay: 0.2 }}
//           className="mt-4 text-xl lg:text-[18px] lg:leading-[28px] text-gray-600 poppins-text "
//         >
//           Sign up to access personalized veterinary care for your beloved furry
//           companions.
//         </motion.p>

//         <form onSubmit={handleSignUp} className="mt-6   text-left">
//           <motion.div
//             variants={textVariants}
//             initial="hidden"
//             animate="visible"
//             transition={{ delay: 0.4 }}
//             className="mb-4"
//           >
//             <Typography variant="h6" className="mb-2 text-left ">
//               Full Name
//             </Typography>
//             <TextField
//               name="full_name"
//               placeholder="Full Name"
//               value={full_name}
//               onChange={onChange}
//               error={Boolean(errors.full_name)}
//               helperText={errors.full_name}
//               variant="outlined"
//               fullWidth
//               className="mb-4"
//               sx={{
//                 "& .MuiOutlinedInput-root": {
//                   borderRadius: "1rem",
//                   backgroundColor: "#f5f5f5",
//                   "& fieldset": {
//                     borderColor: "transparent",
//                   },
//                   "&:hover fieldset": {
//                     borderColor: "#cbd5e1",
//                   },
//                 },
//               }}
//             />
//           </motion.div>

//           <motion.div
//             variants={textVariants}
//             initial="hidden"
//             animate="visible"
//             transition={{ delay: 0.6 }}
//             className="mb-4"
//           >
//             <Typography variant="h6" className="mb-2 text-left ">
//               Email
//             </Typography>
//             <TextField
//               name="email"
//               type="email"
//               placeholder="Email"
//               value={email}
//               onChange={onChange}
//               error={Boolean(errors.email)}
//               helperText={errors.email}
//               variant="outlined"
//               fullWidth
//               className="mb-4"
//               sx={{
//                 "& .MuiOutlinedInput-root": {
//                   borderRadius: "1rem",
//                   backgroundColor: "#f5f5f5",
//                   "& fieldset": {
//                     borderColor: "transparent",
//                   },
//                   "&:hover fieldset": {
//                     borderColor: "#cbd5e1",
//                   },
//                 },
//               }}
//             />
//           </motion.div>

//           <motion.div
//             variants={textVariants}
//             initial="hidden"
//             animate="visible"
//             transition={{ delay: 0.8 }}
//             className="mb-4"
//           >
//             <Typography variant="h6" className="mb-2 text-left">
//               Password
//             </Typography>
//             <TextField
//               type="password"
//               name="password"
//               placeholder="Password"
//               value={password}
//               onChange={onChange}
//               error={Boolean(errors.password)}
//               helperText={errors.password}
//               variant="outlined"
//               fullWidth
//               className="mb-4"
//               sx={{
//                 "& .MuiOutlinedInput-root": {
//                   borderRadius: "1rem",
//                   backgroundColor: "#f5f5f5",
//                   "& fieldset": {
//                     borderColor: "transparent",
//                   },
//                   "&:hover fieldset": {
//                     borderColor: "#cbd5e1",
//                   },
//                 },
//               }}
//             />
//           </motion.div>

//           <motion.div
//             variants={textVariants}
//             initial="hidden"
//             animate="visible"
//             transition={{ delay: 1 }}
//             className="mb-4"
//           >
//             <Typography variant="h6" className="mb-2 text-left">
//               Confirm Password
//             </Typography>
//             <TextField
//               name="confirmPassword"
//               type="password"
//               variant="outlined"
//               placeholder="Confirm Password"
//               value={confirmPassword}
//               onChange={onChange}
//               error={Boolean(errors.confirmPassword)}
//               helperText={errors.confirmPassword}
//               fullWidth
//               className="mb-4"
//               sx={{
//                 "& .MuiOutlinedInput-root": {
//                   borderRadius: "1rem",
//                   backgroundColor: "#f5f5f5",
//                   "& fieldset": {
//                     borderColor: "transparent",
//                   },
//                   "&:hover fieldset": {
//                     borderColor: "#cbd5e1",
//                   },
//                 },
//               }}
//             />
//           </motion.div>

//           <motion.div className="mt-6 flex mb-8 justify-center">
//             <motion.button
//               type="submit"
//               variants={buttonVariants}
//               whileHover="hover"
//               disabled={loading}
//               className="mt-6 text-xl lg:text-[20px] lg:leading-[26px] px-6 py-3 bg-[#967d6c] text-white font-bold rounded-full  w-full"
//             >
//               {loading ? "Signing Up..." : "Proceed to Checkout"}
//             </motion.button>
//           </motion.div>
//         </form>
//         <motion.p
//           className="signup-text text-lg poppins-text lg:text-[18px] lg:leading-[28px]  mb-2"
//           variants={linkVariants}
//           initial="hidden"
//           animate="visible"
//           whileHover="hover"
//         >
//           Already have an account?{" "}
//           <Link
//             to="/login"
//             className="signup-link text-[#967d6c]  hover:underline"
//           >
//             Login Here
//           </Link>
//         </motion.p>
//         {errorMessage && (
//           <Typography color="error" variant="body2" align="center">
//             {errorMessage}
//           </Typography>
//         )}
//       </Container>
//       <motion.div
//         className="absolute left-0 top-20 hidden xl:block"
//         variants={imageVariants}
//         initial="hidden"
//         animate="visible"
//       >
//         <img src={catImage} alt="Cat" className=" h-[36rem] mx-auto"  loading="lazy"/>
//         <div className="absolute left-60 bottom-20 transform -translate-x-1/2 hidden sm:block">
//           <div className="text-6xl text-[#bda697] animate-paw-left-right">
//             <i className="fa fa-paw"></i>
//           </div>
//         </div>
//         <div className="absolute left-64 top-80 transform translate-x-1/2 hidden xl:block">
//           <div className="text-4xl text-[#bda697] animate-paw-left-right">
//             <i className="fa fa-paw"></i>
//           </div>
//         </div>
//       </motion.div>
//       <motion.div
//         className="absolute right-0 top-24 hidden xl:block"
//         variants={{
//           ...imageVariants,
//           hidden: { opacity: 0, x: 100 },
//         }}
//         initial="hidden"
//         animate="visible"
//       >
//         <img src={dogImage} alt="Dog" className="h-[34rem]  mx-auto"    loading="lazy" />
//         <div className="absolute right-24 bottom-2 transform -translate-x-1/2 hidden xl:block">
//           <div className="text-4xl text-[#bda697] animate-paw-left-right">
//             <i className="fa fa-paw"></i>
//           </div>
//         </div>
//         <div className="absolute right-64 bottom-16 transform translate-x-1/2 hidden sm:block">
//           <div className="text-6xl text-[#bda697] animate-paw-left-right">
//             <i className="fa fa-paw"></i>
//           </div>
//         </div>
//       </motion.div>
//       {showInstructions && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
//           <motion.div
//             initial={{ opacity: 0, scale: 0.98 }}
//             animate={{ opacity: 1, scale: 1 }}
//             className="bg-white rounded-2xl shadow-2xl w-11/12 max-w-7xl max-h-[90vh] overflow-y-auto p-6"
//           >
//             <h2 className="text-3xl font-bold text-center mb-4">
//               Add Our Site to Your Home Screen
//             </h2>

//             <div className="grid gap-6 md:grid-cols-2">
//               <div>
//                 <h3 className="text-2xl font-semibold mb-2">
//                   Android (Chrome / Edge / Firefox)
//                 </h3>

//                 <ol className="list-decimal poppins-text list-inside text-left space-y-4 text-gray-700">
//                   <li>
//                     Open your website in <strong>Chrome</strong>,{" "}
//                     <strong>Edge</strong>, or <strong>Firefox</strong> on your
//                     Android device.
//                     <img
//                       src={And1}
//                       alt="android step 1"
//                       className="mt-2  w-40 rounded-lg mx-auto block"
//                     />
//                   </li>

//                   <li>
//                     Tap the <strong>three dots</strong> in the top-right corner
//                     of the browser to open the menu.
//                   </li>

//                   <li>
//                     Select <strong>“Add to Home screen”</strong>. If prompted,
//                     tap <strong>“Install app”</strong>.
//                     <img
//                       src={And2}
//                       alt="android step 3"
//                       className="mt-2  w-40 rounded-lg mx-auto block"
//                     />
//                   </li>

//                   <li>
//                     Confirm by tapping <strong>Add</strong> (or{" "}
//                     <strong>Install</strong> when asked).
//                     <img
//                       src={And3}
//                       alt="android step 4"
//                       className="mt-2  w-40 rounded-lg mx-auto block"
//                     />
//                   </li>

//                   <li>
//                     The website will now appear as an <strong>app icon</strong>{" "}
//                     on your home screen. You can open it just like a normal app
//                     — it will launch in a full-screen view.
//                     <img
//                       src={And4}
//                       alt="android step 5"
//                       className="mt-2  w-40 rounded-lg mx-auto block"
//                     />
//                   </li>
//                 </ol>
//               </div>

//               <div>
//                 <h3 className="text-2xl font-semibold mb-2">iOS (Safari)</h3>
//                 <ol className="list-decimal poppins-text list-inside text-left space-y-3 text-gray-700">
//                   <li>
//                     Open your website in Safari.
//                     <img
//                       src={IOS1}
//                       alt="ios 1"
//                       className="mt-2 w-40 rounded-lg mx-auto block"
//                     />
//                   </li>
//                   <li>
//                     Tap the <strong>three dots</strong> on the bottom-right
//                     corner of the screen.
//                   </li>
//                   <li>
//                     Tap the Share button (the square with an arrow pointing up).
//                     <img
//                       src={IOS2}
//                       alt="ios 2"
//                       className="mt-2  w-40 rounded-lg mx-auto block"
//                     />
//                   </li>
//                   <li>
//                     Scroll down and select{" "}
//                     <strong>“Add to Home Screen.”</strong>
//                     <img
//                       src={IOS3}
//                       alt="ios 3"
//                       className="mt-2  w-40 rounded-lg mx-auto block"
//                     />
//                   </li>
//                   <li>
//                     Give it a name and tap <strong>Add.</strong>
//                     <img
//                       src={IOS4}
//                       alt="ios 4"
//                       className="mt-2  w-40 rounded-lg mx-auto block"
//                     />
//                   </li>
//                   <li>
//                     The website will now appear as an icon on the home screen.
//                   </li>
//                 </ol>
//               </div>
//             </div>

//             {/* <div className="flex justify-center gap-4 mt-6">
//               <motion.button
//                 variants={buttonVariants}
//                 whileHover="hover"
//                 onClick={() => setShowInstructions(false)}
//                 disabled={loading}
//                 className="mt-6 text-xl lg:text-[20px] lg:leading-[26px] px-6 py-3  bg-gray-400 text-white hover:bg-gray-500 font-bold rounded-full  w-full"
//               >
//                  Back
//               </motion.button>

//               <motion.button
//                 onClick={handleConfirmAndProceed}
//                 variants={buttonVariants}
//                 whileHover="hover"
//                 disabled={loading}
//                 className="mt-6 text-xl lg:text-[20px] lg:leading-[26px] px-6 py-3 bg-[#967d6c] text-white font-bold rounded-full  w-full"
//               >
//                 {loading ? "Processing..." : "Continue to Payment"}
//               </motion.button>

         
//             </div> */}
//             <div className="flex lg:justify-center flex-col  lg:flex-row gap-4 mt-6 w-full">
//               {/* Back Button */}
//               <motion.button
//                 variants={buttonVariants}
//                 whileHover="hover"
//                 onClick={() => setShowInstructions(false)}
//                 disabled={loading}
//                 className="text-xl lg:text-[20px] lg:leading-[26px] px-6 py-3 bg-gray-400 text-white hover:bg-gray-500 font-bold rounded-full w-full lg:w-1/3 disabled:opacity-50"
//               >
//                 Back
//               </motion.button>

//               {/* Continue Button */}
//               <motion.button
//                 onClick={handleConfirmAndProceed}
//                 variants={buttonVariants}
//                 whileHover="hover"
//                 disabled={loading}
//                 className="text-xl lg:text-[20px] lg:leading-[26px] px-6 py-3 bg-[#967d6c] text-white font-bold rounded-full w-full lg:w-1/3 disabled:opacity-50"
//               >
//                 {loading ? "Processing..." : "Continue to Payment"}
//               </motion.button>
//             </div>
//           </motion.div>
//         </div>
//       )}
//     </section>
//   );
// };



// export default Signup;


import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import {
  TextField,
  Container,
  Typography,
  InputAdornment,
  IconButton,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import catImage from "../images/homecat1.avif";
import dogImage from "../images/homeimg.avif";
import IOS1 from "../images/IOS1.jpeg";
import IOS2 from "../images/IOS2.jpeg";
import IOS3 from "../images/IOS3.jpeg";
import IOS4 from "../images/IOS4.jpeg";
import And1 from "../images/android1.jpeg";
import And2 from "../images/android2.jpeg";
import And3 from "../images/android3.jpeg";
import And4 from "../images/android4.jpeg";
import Navbar from "./Navbar.js";
import axiosInstance from "../api/axios";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { Helmet } from "react-helmet-async";
import PetLoader from "./Petloader.js";

// ─── Step data ────────────────────────────────────────────────────────────────
const IOS_STEPS = [
  { img: IOS1, text: "Open your website in <strong>Safari</strong> on your iPhone or iPad." },
  { img: IOS2, text: "Tap the <strong>three dots</strong> on the bottom-right corner, then tap the <strong>Share</strong> button (square with arrow)." },
  { img: IOS3, text: 'Scroll down and tap <strong>"Add to Home Screen."</strong>' },
  { img: IOS4, text: "Give it a name and tap <strong>Add.</strong> Done — it'll appear like a real app!" },
];

const ANDROID_STEPS = [
  { img: And1, text: "Open your website in <strong>Chrome</strong>, <strong>Edge</strong>, or <strong>Firefox</strong>." },
  { img: And2, text: 'Tap the <strong>three dots</strong> in the top-right corner, then choose <strong>"Add to Home screen"</strong>.' },
  { img: And3, text: "Tap <strong>Add</strong> or <strong>Install</strong> when prompted." },
  { img: And4, text: "The app icon will appear on your home screen — tap it to launch in full-screen!" },
];

// ─── Step card ─────────────────────────────────────────────────────────────────
const StepCard = ({ step, index, img, text }) => (
  <motion.div
    initial={{ opacity: 0, y: 16 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: index * 0.07, duration: 0.4, ease: "easeOut" }}
    className="flex gap-4 items-start p-4 rounded-2xl"
    style={{ background: "rgba(150, 125, 108, 0.06)", border: "1px solid rgba(150, 125, 108, 0.12)" }}
  >
    {/* Step number */}
    <div
      className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-bold"
      style={{ background: "linear-gradient(135deg, #967d6c, #bda697)" }}
    >
      {index + 1}
    </div>
    {/* Text */}
    <div className="flex-1 min-w-0">
      <p
        className="text-gray-700 text-sm leading-relaxed poppins-text"
        dangerouslySetInnerHTML={{ __html: text }}
      />
      {img && (
        <motion.img
          initial={{ opacity: 0, scale: 0.97 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: index * 0.07 + 0.15, duration: 0.35 }}
          src={img}
          alt={`Step ${index + 1}`}
          className="mt-3 rounded-xl shadow-md object-cover"
          style={{ width: "120px", border: "2px solid rgba(150,125,108,0.18)" }}
          loading="lazy"
        />
      )}
    </div>
  </motion.div>
);

// ─── Platform Tab panel ────────────────────────────────────────────────────────
const PlatformPanel = ({ steps }) => (
  <div className="flex flex-col gap-3 mt-4">
    {steps.map((s, i) => (
      <StepCard key={i} index={i} img={s.img} text={s.text} />
    ))}
  </div>
);

// ─── Instructions Modal ────────────────────────────────────────────────────────
const InstructionsModal = ({ onBack, onContinue, loading }) => {
  const [activeTab, setActiveTab] = useState("android");

  const buttonVariants = {
    hover: { backgroundColor: "#BDA697", transition: { duration: 0.3 } },
  };

  return (
    <AnimatePresence>
      <motion.div
        key="overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="fixed inset-0 z-50 flex items-center justify-center p-4"
        style={{ backgroundColor: "rgba(20, 14, 10, 0.65)", backdropFilter: "blur(8px)" }}
      >
        <motion.div
          key="modal"
          initial={{ opacity: 0, scale: 0.96, y: 24 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.97, y: 12 }}
          transition={{ type: "spring", stiffness: 280, damping: 26 }}
          className="bg-white rounded-3xl shadow-2xl w-full max-w-2xl overflow-hidden"
          style={{ maxHeight: "90vh", display: "flex", flexDirection: "column" }}
        >
          {/* Header */}
          <div
            className="px-8 pt-8 pb-6 flex-shrink-0"
            style={{ background: "linear-gradient(135deg, rgba(150,125,108,0.08) 0%, rgba(189,166,151,0.05) 100%)" }}
          >
            <div className="flex items-center justify-center gap-3 mb-2">
              <div
                className="w-10 h-10 rounded-2xl flex items-center justify-center"
                style={{ background: "linear-gradient(135deg, #967d6c, #bda697)" }}
              >
                <i className="fa fa-paw text-white text-lg" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900" style={{ fontFamily: "'Poppins', sans-serif" }}>
                One Last Step!
              </h2>
            </div>
            <p className="text-center text-gray-500 text-sm poppins-text">
              Add Furbabies.AI to your home screen for the best experience — it works just like a native app.
            </p>
          </div>

          {/* Tab switcher */}
          <div className="px-8 flex-shrink-0">
            <div
              className="flex rounded-2xl p-1 gap-1"
              style={{ background: "rgba(150, 125, 108, 0.08)" }}
            >
              {[
                { id: "android", label: "🤖 Android", icon: "android" },
                { id: "ios", label: "🍎 iOS / iPhone", icon: "ios" },
              ].map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className="flex-1 py-2.5 px-4 rounded-xl text-sm font-semibold transition-all duration-250 poppins-text"
                  style={{
                    background: activeTab === tab.id
                      ? "linear-gradient(135deg, #967d6c, #bda697)"
                      : "transparent",
                    color: activeTab === tab.id ? "white" : "#967d6c",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>

          {/* Scrollable steps area */}
          <div className="flex-1 overflow-y-auto px-8 py-4" style={{ minHeight: 0 }}>
            <AnimatePresence mode="wait">
              <motion.div
                key={activeTab}
                initial={{ opacity: 0, x: activeTab === "ios" ? 20 : -20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: activeTab === "ios" ? -20 : 20 }}
                transition={{ duration: 0.25, ease: "easeInOut" }}
              >
                <PlatformPanel steps={activeTab === "android" ? ANDROID_STEPS : IOS_STEPS} />
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Footer actions */}
          <div
            className="px-8 py-6 flex flex-col sm:flex-row gap-3 flex-shrink-0"
            style={{ borderTop: "1px solid rgba(150,125,108,0.12)" }}
          >
            <motion.button
              whileHover={{ backgroundColor: "#e5e7eb" }}
              onClick={onBack}
              disabled={loading}
              className="flex-1 py-3 px-6 rounded-full font-bold text-gray-600 text-base transition-colors disabled:opacity-50 poppins-text"
              style={{ background: "#f3f4f6", border: "none", cursor: "pointer" }}
            >
              ← Back
            </motion.button>

            <motion.button
              variants={buttonVariants}
              whileHover="hover"
              onClick={onContinue}
              disabled={loading}
              className="flex-1 py-3 px-6 rounded-full font-bold text-white text-base disabled:opacity-50 poppins-text"
              style={{
                background: "linear-gradient(135deg, #967d6c, #bda697)",
                border: "none",
                cursor: loading ? "not-allowed" : "pointer",
              }}
            >
              {loading ? (
                <span className="flex items-center justify-center gap-2">
                  <motion.i
                    className="fa fa-paw"
                    animate={{ rotate: 360 }}
                    transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
                  />
                  Processing...
                </span>
              ) : (
                "Continue to Payment →"
              )}
            </motion.button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

// ─── Main Signup Component ─────────────────────────────────────────────────────
const Signup = () => {
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    password: "",
    confirmPassword: "",
    priceId: "price_1SpBOi046YZkLcO5SDUsSyB4",
  });
  const [loading, setLoading] = useState(false);
  const [loaderMessage, setLoaderMessage] = useState("Checking your details...");
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [showInstructions, setShowInstructions] = useState(false);

    const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const { full_name, email, password, confirmPassword, priceId } = formData;

  const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "1rem",
    backgroundColor: "#f5f5f5",
    "& fieldset": { borderColor: "transparent" },
    "&:hover fieldset": { borderColor: "#cbd5e1" },
  },
};


  const validateForm = () => {
    const newErrors = {};
    if (!full_name) newErrors.full_name = "Full name is required";
    if (!email) {
      newErrors.email = "Email is required";
    } else {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(email)) newErrors.email = "Email is invalid. Please enter a valid email address.";
    }
    if (!password) {
      newErrors.password = "Password is required";
    } else {
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;
      if (!passwordRegex.test(password)) {
        newErrors.password = "Password must be at least 6 characters long, contain at least one uppercase letter, one lowercase letter, one number, and one special character.";
      }
    }
    if (password !== confirmPassword) newErrors.confirmPassword = "Passwords do not match";
    return newErrors;
  };

  const getDeviceFingerprint = async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    return result.visitorId;
  };

  const getUserIP = async () => {
    try {
      const response = await fetch("https://api.ipify.org?format=json");
      const data = await response.json();
      return data.ip;
    } catch (err) {
      console.error("Error fetching IP:", err);
      return "unknown";
    }
  };

  const checkEmailExists = async (email) => {
    try {
      const fingerprint = await getDeviceFingerprint();
      const ip = await getUserIP();
      const response = await axiosInstance.post("/check-email", { email, fingerprint, ip });
      return response.data;
    } catch (error) {
      console.error("Error checking email", error);
      return { exists: false, verified: false, error: "Error checking email" };
    }
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setErrors({});

    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setLoaderMessage("Checking your details...");
    setLoading(true);

    const messages = [
      { text: "Checking your details...", delay: 0 },
      { text: "Waking up the server 🐾", delay: 5000 },
      { text: "Verifying your email...", delay: 15000 },
      { text: "Almost ready...", delay: 30000 },
    ];
    const timers = messages.map(({ text, delay }) =>
      setTimeout(() => setLoaderMessage(text), delay)
    );

    try {
      const emailCheck = await checkEmailExists(email);
      timers.forEach(clearTimeout);

      if (emailCheck.exists) {
        setErrors({ email: "This email is already in use" });
        setLoading(false);
        return;
      }
      if (!emailCheck.verified) {
        setErrors({ email: emailCheck.error || "Email not verified" });
        setLoading(false);
        return;
      }

      setLoading(false);
      setShowInstructions(true);
    } catch (err) {
      timers.forEach(clearTimeout);
      setErrorMessage("Error during sign-up");
      console.error(err);
      setLoading(false);
    }
  };

  const handleConfirmAndProceed = async () => {
    setErrorMessage("");
    setLoaderMessage("Setting up your account...");
    setLoading(true);

    const messages = [
      { text: "Setting up your account...", delay: 0 },
      { text: "Server is waking up 🐾", delay: 5000 },
      { text: "Creating your session...", delay: 18000 },
      { text: "Preparing checkout...", delay: 35000 },
    ];
    const timers = messages.map(({ text, delay }) =>
      setTimeout(() => setLoaderMessage(text), delay)
    );

    let fingerprint = null;
    let ip = null;

    try {
      fingerprint = await getDeviceFingerprint();
      ip = await getUserIP();

      const payload = { full_name, email, password, ip, fingerprint, priceId, isGoogle: "No", googleId: "No" };
      const createResp = await axiosInstance.post("/create-checkout-session", payload);
      const { sessionId } = createResp.data || {};

      timers.forEach(clearTimeout);

      if (!sessionId) throw new Error("No sessionId returned from server");

      setLoaderMessage("Redirecting to payment...");
      const stripe = window.Stripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
      const { error } = await stripe.redirectToCheckout({ sessionId });

      if (error) {
        setErrorMessage(error.message || "Stripe redirect error");
        setLoading(false);
      }
    } catch (err) {
      timers.forEach(clearTimeout);
      console.error("Error in confirm+proceed:", err);
      setErrorMessage(err.response?.data?.detail || err.message || "Checkout failed");
      setLoading(false);
    } finally {
      fingerprint = null;
      ip = null;
      setFormData((prev) => ({ ...prev, password: "", confirmPassword: "" }));
      setShowInstructions(false);
    }
  };

  const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } },
  };
  const buttonVariants = {
    hover: { backgroundColor: "#BDA697", transition: { duration: 0.3 } },
  };
  const imageVariants = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0, transition: { duration: 1 } },
  };
  const linkVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  return (
    <section className="relative text-center mt-20 pt-16">
      <Helmet>
        <title>Sign Up Free – Furbabies.AI</title>
        <meta name="description" content="Create your free Furbabies.AI account and start monitoring your pet's health and nutrition with AI today. No credit card required." />
      </Helmet>

      {/* Production-grade loader */}
      <PetLoader isVisible={loading} message={loaderMessage} />

      <Navbar />
      <Container maxWidth="sm" className="mt-10">
        <motion.h1
          variants={textVariants}
          initial="hidden"
          animate="visible"
          className="text-5xl lg:text-[60px] lg:leading-[70px] font-bold text-gray-900"
        >
          Care Today
        </motion.h1>
        <motion.p
          variants={textVariants}
          initial="hidden"
          animate="visible"
          transition={{ delay: 0.2 }}
          className="mt-4 text-xl lg:text-[18px] lg:leading-[28px] text-gray-600 poppins-text"
        >
          Sign up to access personalized veterinary care for your beloved furry companions.
        </motion.p>

         <form onSubmit={handleSignUp} className="mt-6 text-left">
 {/* Full Name */}
          <motion.div variants={textVariants} initial="hidden" animate="visible" transition={{ delay: 0.4 }} className="mb-4">
            <Typography variant="h6" className="mb-2 text-left">Full Name</Typography>
            <TextField
              name="full_name"
              type="text"
              placeholder="Full Name"
              value={formData.full_name}
              onChange={onChange}
              error={Boolean(errors.full_name)}
              helperText={errors.full_name}
              variant="outlined"
              fullWidth
              sx={fieldSx}
            />
          </motion.div>
 
          {/* Email */}
          <motion.div variants={textVariants} initial="hidden" animate="visible" transition={{ delay: 0.6 }} className="mb-4">
            <Typography variant="h6" className="mb-2 text-left">Email</Typography>
            <TextField
              name="email"
              type="email"
              placeholder="Email"
              value={formData.email}
              onChange={onChange}
              error={Boolean(errors.email)}
              helperText={errors.email}
              variant="outlined"
              fullWidth
              sx={fieldSx}
            />
          </motion.div>

         <motion.div variants={textVariants} initial="hidden" animate="visible" transition={{ delay: 0.8 }} className="mb-4">
            <Typography variant="h6" className="mb-2 text-left">Password</Typography>
            <TextField
              name="password"
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={formData.password}
              onChange={onChange}
              error={Boolean(errors.password)}
              helperText={errors.password}
              variant="outlined"
              fullWidth
              inputProps={{ autoComplete: "new-password" }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword((prev) => !prev)}
                      edge="end"
                      tabIndex={-1}
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={fieldSx}
            />
          </motion.div>
 
          {/* Confirm Password */}
          <motion.div variants={textVariants} initial="hidden" animate="visible" transition={{ delay: 1.0 }} className="mb-4">
            <Typography variant="h6" className="mb-2 text-left">Confirm Password</Typography>
            <TextField
              name="confirmPassword"
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm Password"
              value={formData.confirmPassword}
              onChange={onChange}
              error={Boolean(errors.confirmPassword)}
              helperText={errors.confirmPassword}
              variant="outlined"
              fullWidth
              inputProps={{ autoComplete: "new-password" }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowConfirmPassword((prev) => !prev)}
                      edge="end"
                      tabIndex={-1}
                    >
                      {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={fieldSx}
            />
          </motion.div>
 <motion.div className="mt-6 flex mb-8 justify-center">
            <motion.button
              type="submit"
              variants={buttonVariants}
              whileHover="hover"
              disabled={loading}
              className="mt-6 text-xl lg:text-[20px] lg:leading-[26px] px-6 py-3 bg-[#967d6c] text-white font-bold rounded-full w-full disabled:opacity-60"
            >
              Proceed to Checkout
            </motion.button>
          </motion.div>
        </form>

        <motion.p
          className="signup-text text-lg poppins-text lg:text-[18px] lg:leading-[28px] mb-2"
          variants={linkVariants}
          initial="hidden"
          animate="visible"
        >
          Already have an account?{" "}
          <Link to="/login" className="signup-link text-[#967d6c] hover:underline">Login Here</Link>
        </motion.p>

        {errorMessage && (
          <Typography color="error" variant="body2" align="center">{errorMessage}</Typography>
        )}
      </Container>

      {/* Decorative images */}
      <motion.div className="absolute left-0 top-20 hidden xl:block" variants={imageVariants} initial="hidden" animate="visible">
        <img src={catImage} alt="Cat" className="h-[36rem] mx-auto" loading="lazy" />
        <div className="absolute left-60 bottom-20 transform -translate-x-1/2 hidden sm:block">
          <div className="text-6xl text-[#bda697] animate-paw-left-right"><i className="fa fa-paw"></i></div>
        </div>
        <div className="absolute left-64 top-80 transform translate-x-1/2 hidden xl:block">
          <div className="text-4xl text-[#bda697] animate-paw-left-right"><i className="fa fa-paw"></i></div>
        </div>
      </motion.div>

      <motion.div className="absolute right-0 top-24 hidden xl:block" variants={{ ...imageVariants, hidden: { opacity: 0, x: 100 } }} initial="hidden" animate="visible">
        <img src={dogImage} alt="Dog" className="h-[34rem] mx-auto" loading="lazy" />
        <div className="absolute right-24 bottom-2 transform -translate-x-1/2 hidden xl:block">
          <div className="text-4xl text-[#bda697] animate-paw-left-right"><i className="fa fa-paw"></i></div>
        </div>
        <div className="absolute right-64 bottom-16 transform translate-x-1/2 hidden sm:block">
          <div className="text-6xl text-[#bda697] animate-paw-left-right"><i className="fa fa-paw"></i></div>
        </div>
      </motion.div>

      {/* Improved Instructions Modal */}
      {showInstructions && (
        <InstructionsModal
          onBack={() => setShowInstructions(false)}
          onContinue={handleConfirmAndProceed}
          loading={loading}
        />
      )}
    </section>
  );
};

export default Signup;